import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-2 ml-2" }, [
    /*#__PURE__*/ _createElementVNode("h6", { class: "fw-bold" }, "Positionen / Artikel")
], -1);
const _hoisted_2 = { class: "mb-4 data-box__card" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
const _hoisted_4 = { style: { "display": "flex", "flex-direction": "row" } };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "text-muted" }, "Artikelnummer:", -1);
const _hoisted_7 = {
    style: { "flex": "1 1 auto" },
    class: "text-end"
};
const _hoisted_8 = { class: "text-black" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cart.lines, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: item.lineID,
                    class: "item"
                }, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                            _createTextVNode(_toDisplayString(item.caption1), 1),
                            _hoisted_5,
                            _hoisted_6,
                            _createTextVNode(" " + _toDisplayString(item.itemNumber), 1)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, [
                                _createElementVNode("b", null, _toDisplayString(item.totalNetAmountText), 1)
                            ])
                        ])
                    ])
                ]));
            }), 128))
        ])
    ], 64));
}
